module.exports = __webpack_public_path__ + "img/belatra.1b994bf5.svg";